import { memo, useCallback } from 'react'
import { Close } from '@mui/icons-material'
import { Chip } from '@mui/material'

type FilterChipProps = {
  filter: { value: string }
  getFilterLabel: (
    filterValue: string,
    type: 'goals' | 'allergens' | 'dietaries' | 'categories',
  ) => string
  handleRemoveFilter: (
    type: 'goals' | 'allergens' | 'dietaries' | 'categories',
    filterValue: string,
  ) => void
  type: 'goals' | 'allergens' | 'dietaries' | 'categories'
}

const FilterChipComponent = memo(
  ({ filter, getFilterLabel, handleRemoveFilter, type }: FilterChipProps) => {
    const onDelete = useCallback(() => {
      handleRemoveFilter(type, filter.value)
    }, [handleRemoveFilter, type, filter.value])

    return (
      <Chip
        label={getFilterLabel(filter.value, type)}
        size="small"
        onDelete={onDelete}
        deleteIcon={<Close />}
      />
    )
  },
  (prevProps, nextProps) => {
    return (
      prevProps.filter.value === nextProps.filter.value &&
      prevProps.type === nextProps.type &&
      prevProps.getFilterLabel === nextProps.getFilterLabel &&
      prevProps.handleRemoveFilter === nextProps.handleRemoveFilter
    )
  },
)

FilterChipComponent.displayName = 'FilterChip'

export const FilterChip = FilterChipComponent
